import { RecodeSamsonWbType } from "../wb/recode"
import { RecodeSamsonYaType } from "../ya/recode"

export const SAMSON_RECODE_SCHEMA_JSON = {
  article: {
    prop: "article",
    type: Number,
    required: true,
  },
  GoodCode: {
    prop: "GoodCode",
    type: String,
    required: true,
  },
  nmId: {
    prop: "nmId",
    type: Number,
    required: true,
  },
  sku: {
    prop: "sku",
    type: String,
    required: true,
  },
  count: {
    prop: "count",
    type: Number,
    required: true,
  },
  sizes: {
    prop: "sizes",
    type: String,
    required: true,
  },
  commission: {
    prop: "commission",
    type: Number,
    required: false,
  },
}

export const SAMSON_RECODE_SCHEMA_EXCEL = [
  {
    column: "article",
    value: (item: RecodeSamsonWbType) => item.article,
  },
  {
    column: "GoodCode",
    value: (item: RecodeSamsonWbType) => item.GoodCode,
  },
  {
    column: "nmId",
    value: (item: RecodeSamsonWbType) => item.nmId,
  },
  {
    column: "sku",
    value: (item: RecodeSamsonWbType) => item.sku,
  },
  {
    column: "count",
    value: (item: RecodeSamsonWbType) => item.count,
  },
  {
    column: "sizes",
    value: (item: RecodeSamsonWbType) => item.sizes,
  },
  {
    column: "commission",
    value: (item: RecodeSamsonWbType) => item.commission,
  },
]

export const SAMSON_RECODE_SCHEMA = {
  WB: {
    JSON: SAMSON_RECODE_SCHEMA_JSON,
    EXCEL: SAMSON_RECODE_SCHEMA_EXCEL,
  },
  YA: {
    JSON: {
      article: {
        prop: "article",
        type: Number,
        required: true,
      },
      offer_id: {
        prop: "offer_id",
        type: String,
        required: true,
      },
      count: {
        prop: "count",
        type: Number,
        required: true,
      },
      weight: {
        prop: "weight",
        type: Number,
        required: true,
      },
      sizes: {
        prop: "sizes",
        type: String,
        required: true,
      },
    },
    EXCEL: [
      {
        column: "article",
        value: (item: RecodeSamsonYaType) => item.article,
      },
      {
        column: "offer_id",
        value: (item: RecodeSamsonYaType) => item.offer_id,
      },
      {
        column: "count",
        value: (item: RecodeSamsonYaType) => item.count,
      },
      {
        column: "weight",
        value: (item: RecodeSamsonYaType) => item.weight,
      },
      {
        column: "sizes",
        value: (item: RecodeSamsonYaType) => item.sizes,
      },
    ],
  },
}
